import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import { MatTableDataSource } from '@angular/material/table';
import { EMPTY, merge, Subject } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { UserReport, UserService, AdminService } from 'src/app/core';
import { SubSink } from 'subsink';
import { AdminDocumentPreviewComponent } from '../dialogs/admin-document-preview/admin-document-preview.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EditUserScoreComponent } from './edit-user-score/edit-user-score.component';

@Component({
  selector: 'admin-user-scores-list',
  templateUrl: './admin-user-scores-list.component.html',
  styleUrls: ['./admin-user-scores-list.component.sass'],
})
export class AdminUserScoresListComponent implements OnInit {
  @Input('userReport') userReport!: UserReport;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('type') documentTypes!: MatSelect;

  public refreshController = new Subject();

  public isRateLimitReached: boolean = false;
  public isLoadingResult: boolean = false;
  public resultsLength: number = 0;

  public dataSource = new MatTableDataSource<any>();
  public displayedColumns: string[] = [
    'id',
    'recievied',
    'paid',
    'total',
    'reason',
    'date',
    'user',
  ];

  // ------------------------------------------------Private methods|

  private subsink = new SubSink();
  private previewDialogRef!: MatDialogRef<AdminDocumentPreviewComponent>;

  // ------------------------------------------------Constructor|

  constructor(
    private userService: UserService,
    private cdr: ChangeDetectorRef,
    private adminService: AdminService,
    private dialog: MatDialog
  ) {}

  public dialogConfig: MatDialogConfig = {
    width: '60%',
    height: '100%',
    maxWidth: 600,
    minWidth: 400,
    maxHeight: 400,
  };

  ngOnInit(): void {
    // this.subsink.sink = this.userService.getAdminUserScoresById(this.userReport.user_id).subscribe(res => {
    //   console.log('here');
    //   console.log(res);
    // })
  }

  public getDate(date: string): Date {
    return new Date(date);
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;

    merge(this.paginator.page, this.refreshController)
      .pipe(
        startWith({}),
        switchMap((value: any, index: any) => {
          this.isLoadingResult = true;
          this.cdr.detectChanges();
          return this.userService
            .getAdminUserScoresById(this.userReport.user_id, {
              page: this.paginator.pageIndex + 1,
              limit: this.paginator.pageSize,
            })
            .pipe(catchError(() => EMPTY));
        }),
        map((data) => {
          this.isLoadingResult = false;
          this.isRateLimitReached = data.items.length === 0;
          this.cdr.detectChanges();

          if (this.isRateLimitReached) {
            return [];
          }

          this.resultsLength = data.meta.totalItems + 1;
          return data.items;
        })
      )
      .subscribe((data) => (this.dataSource = new MatTableDataSource(data)));
  }

  editUserScore() {
    this.dialog
      .open(EditUserScoreComponent, {
        ...this.dialogConfig,
        data: {
          userId: this.userReport.user_id,
        },
      })
      .afterClosed()
      .subscribe((res: any) => {
        this.ngAfterViewInit();
      });
  }
}
